'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/axios/lib/cancel/isCancel.js
// module id = 63
// module chunks = 0